export enum ReasonRefund {
  EMPTY_REASON = 'EMPTY_REASON',
  LIGHT_VEHICLE_COSTS = 'LIGHT_VEHICLE_COSTS',
  CANCELLED_TRANSPORT = 'CANCELLED_TRANSPORT',
  TARIFF_ERROR = 'TARIFF_ERROR',
  TRANSPORT_NOT_SUBJECT_TO_VAT = 'TRANSPORT_NOT_SUBJECT_TO_VAT',
  LATE_DELIVERY = 'LATE_DELIVERY',
  QUANTITY_CHANGE = 'QUANTITY_CHANGE',
  COMMERCIAL_GESTURE = 'COMMERCIAL_GESTURE',
  OTHER = 'OTHER',
}
